import React, { Component } from 'react'
import { Button, Panel } from 'react-bootstrap'
import DeleteOrDiscardModal from '../../common/components/deleteOrDiscardModal'
import TriggersTable from '../../common/components/triggersTable'
import FormField from '../../common/form/formField'

class SchedulePanel extends Component {
  constructor(props) {
    super(props)

    const schedule = props.model.schedule || {}
    this.state = {
      comingSoon: schedule.displayFromDateTime !== schedule.redeemFromDateTime,
      extendVisibility: schedule.displayToDateTime !== schedule.redeemToDateTime
    }

    this.onConfirmationDeleteTrigger = this.onConfirmationDeleteTrigger.bind(this)
    this.onEditTrigger = this.onEditTrigger.bind(this)
  }

  onConfirmationDeleteTrigger(index) {
    this.showDeleteOrDiscard('Trigger')
    this.setState({ indexToBeDeleted: index })
  }

  showDeleteOrDiscard(type) {
    this.setState({ deleteOrDiscardModalVisible: true })
    this.deleteType = type
  }

  onDelete(indexToBeDeleted, type) {
    this.model = this.props.model
    this.model.schedule.triggers.splice(indexToBeDeleted, 1)
    this.props.saveArticle(this.model)
  }

  onEditTrigger(index) {
    this.props.navigateToEditOurPicksTrigger(this.props.model, index)
  }

  render() {
    const schedule = this.props.model.schedule || {}
    const formDisabled = this.props.formDisabled
    const validationErrors = this.props.validationErrors
    const updateField = this.props.updateField

    return (
      <div>
        <Panel header='Schedule' id='schedule'>
          <FormField label='Visible from' type='datetime' id='display-from'
                     mandatory
                     value={schedule.displayFromDateTime || ''}
                     onChange={(value) => updateField('schedule.displayFromDateTime', value)()}
                     disabled={formDisabled}
                     error={validationErrors.schedule.displayFromDateTime}
          />
          <FormField label='Visible to' type='datetime' id='display-to'
                     mandatory
                     value={schedule.displayToDateTime || ''}
                     onChange={(value) => updateField('schedule.displayToDateTime', value)()}
                     disabled={formDisabled}
                     error={validationErrors.schedule.displayToDateTime}
          />
          <FormField label='Published date' type='datetime' id='publish-date'
                     mandatory
                     value={schedule.publishDate || ''}
                     onChange={(value) => updateField('schedule.publishDate', value)()}
                     disabled={formDisabled}
                     error={validationErrors.schedule.publishDate}
                     dateOnly
          />
        </Panel>

        <Panel header='Our Picks Trigger'>
          <div className='page-header--tools'>
            <Button disabled={formDisabled} bsStyle='primary' id='create-trigger' onClick={() => this.props.navigateToNewOurPicksTrigger(this.props.model)}>New Trigger</Button>
            <div className='triggers-list'>
              <TriggersTable triggers={schedule.triggers}
                             validationErrors={validationErrors}
                             onConfirmationDelete={this.onConfirmationDeleteTrigger}
                             onEditTrigger={this.onEditTrigger}
                             formDisabled={formDisabled}
              />
            </div>
          </div>
        </Panel>
        <DeleteOrDiscardModal visible={this.state.deleteOrDiscardModalVisible}
                              message={'Do you want to delete this ' + this.deleteType + '?'}
                              onDelete={() => {
                                this.onDelete(this.state.indexToBeDeleted, this.deleteType)
                                this.setState({ deleteOrDiscardModalVisible: false })
                              }}
                              onDiscard={() => {
                                this.setState({ deleteOrDiscardModalVisible: false })
                                this.props.navigateToSchedule(this.props.model.id)
                              }
                              }
        />
      </div>
    )
  }
}

export default SchedulePanel
